export default __webpack_public_path__ + "static/toolsDevTablet-6eafcdd1d0c07e2fc53de98cf378b2ce.png";